import { Box } from '@mui/material';

export const Abdm = () => {
    return <Box sx={{ flex: 1 }}></Box>;
};
